var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "hot-info-box",
    on: {
      "click": _vm.handleHotInfo
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('img', {
    staticClass: "info-img",
    attrs: {
      "src": _vm.info.new_image,
      "onerror": `javascript:this.src='${_vm.defaultImg}';`
    }
  }), _c('div', {
    staticClass: "content"
  }, [_vm.info.text ? _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.info.text) + " ")]) : _vm._e(), _vm.info.text && _vm.info.title ? _c('span', {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.info.title ? _c('span', {
    staticClass: "text"
  }, [_vm._v("“ " + _vm._s(_vm.info.title) + "”")]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };